<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name:"App"
}
</script>
<style>
.text-all-center {
  text-align: -webkit-center !important;
  text-align: -moz-center !important;
  text-align: center;
}
.ck-editor__editable {
  min-height: 175px;
}
.p-inputtext,
.p-calendar {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.p-inputtext:enabled:hover,
.p-inputnumber-input:enabled:hover,
.p-calendar .p-inputtext:enabled:hover {
  border-color: none !important;
}
.p-inputtext:enabled:focus,
.p-inputnumber-input:enabled:focus,
.p-calendar .p-inputtext:enabled:focus {
  box-shadow: none !important;
  border-color: #6366F1 !important;
  border-width: 1px;
  box-shadow: #6366F1 0 0 0 calc(2px + var(--tw-ring-offset-width)) #6366F1;
}
.p-calendar, .p-inputtext, .p-inputnumber-input {
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid #D1D5DB;
}

.p-toast .p-toast-message .p-toast-message-content {
  border-width: 0 !important;
}

.litepie-datepicker {
  z-index: 50;
}

/* Animation */
@import url('https://cdn.jsdelivr.net/npm/animate.css@3.5.1');

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s linear;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}

.zoom-enter-active,
.zoom-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.zoom-enter-active {
  animation: bounce-in .5s;
}

.zoom-leave-active {
  animation: bounce-in .5s reverse;
}

.zoom-enter-from,
.zoom-leave-to {
  opacity: 0;
  transform: scale(0.3);
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>